/*
 * Slugs represents portion of a URL.
 * We need to validate slugs for hostnames, pages, spaces, collections.
 */

import mem from 'mem';

import { getSlug as getSlugInternal } from '@gitbook/util-slug';

/**
 * Gets the normalized slug for a string.
 *
 * Avoid calling into limax (which is slow) if path is already slug
 * this helps avoid pointless (re)normalization when loading pages
 * with already valid slugs from the DB (bottleneck on large TOCs)
 */
export const getSlug = mem(
    (str: string, allowPathChars: boolean) =>
        getSlugInternal(str, {
            tone: false,
            custom: allowPathChars ? { '.': '.', '+': '+' } : { _: '-' },
            separateNumbers: false,
        }),
    { cacheKey: ([str, allowPathChars]) => `${str}/${allowPathChars}` }
);
